import { Input } from 'antd'
import { TextAreaProps } from 'antd/lib/input'
import KFormItem from 'app/components/Modules/Form/KFormItem'
import { KInputTextProps } from 'app/components/Modules/Form/typing'
import * as React from 'react'

const KTextArea: React.FC<
  React.ComponentProps<typeof KFormItem> & KInputTextProps & TextAreaProps
> = ({ required, recordTypeOverride, ...props }) => {
  return (
    <KFormItem
      labelCol={{ span: 24 }}
      wrapperCol={{ span: 24 }}
      rules={props.rules}
      name={props.name}
      required={required}
      recordTypeOverride={recordTypeOverride}
      readonly={props.readOnly}
      label={props.label}
      hasFeedback={props.hasFeedback}
      hidden={props.hidden}
      labelRenderer={props.labelRenderer}>
      <Input.TextArea rows={props.rows} allowClear={props.allowClear} />
    </KFormItem>
  )
}

export default KTextArea
